import i18n from "i18next";
import { faProjectDiagram } from "@fortawesome/pro-regular-svg-icons";
import { AsyncButton, AsyncButtonProps } from "src/components/common/buttons/AsyncButton.tsx";
import { useGenericDialog } from "src/components/common/dialogs/GenericDialogContext.ts";
import { ProjectTreeViewContainer } from "src/components/views/erp/project/treeView/ProjectTreeViewContainer.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface OpenProjectInTreeViewButtonProps extends Omit<AsyncButtonProps, "onClick"> {
	projectId: number | null | undefined;
}

export const OpenProjectInTreeViewButton = ({
	projectId,
	variant = "menu",
	...other
}: OpenProjectInTreeViewButtonProps) => {
	const { openDialog } = useGenericDialog();
	if (projectId == null) return null;
	return (
		<AsyncButton
			label={i18n.t("open_project")}
			icon={faProjectDiagram}
			variant={variant}
			onClick={() => {
				openDialog({
					title: i18n.t("project"),
					agentContext: {
						key: defineAgentUiContextKey("erp.project.project.openProjectInTreeViewButton.dialog"),
						data: { projectId },
						pathSegments: [`${i18n.t("project")} ${projectId}`],
					},
					content: <ProjectTreeViewContainer onlyProjectId={projectId} />,
				});
			}}
			{...other}
		/>
	);
};
